import { render, staticRenderFns } from "./PriceListsList.vue?vue&type=template&id=8d4af8a8&scoped=true&"
import script from "./PriceListsList.vue?vue&type=script&lang=js&"
export * from "./PriceListsList.vue?vue&type=script&lang=js&"
import style0 from "./PriceListsList.vue?vue&type=style&index=0&id=8d4af8a8&lang=scss&scoped=true&"
import style1 from "./PriceListsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4af8a8",
  null
  
)

export default component.exports